import { Navigate } from 'react-router-dom'
import { isPostLoginRestoreNavigationState } from '../../utils/navigationState'

export const getAccessDeniedRedirectElement = (
    locationState: unknown,
    redirectTo: string = '/'
) =>
    isPostLoginRestoreNavigationState(locationState) ? (
        <Navigate to={redirectTo} replace />
    ) : null
